import { Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import AdminLogin from "./component/adminlogin/AdminLogin";
import ForgotPassword from "./component/adminlogin/ForgotPassword";
import OtpPage from "./component/adminlogin/OtpPage";
import ResetPassword from "./component/adminlogin/ResetPassword";
import Home from "./component/home/Home";
import Account from "./component/navbar component/account/Account";
import Settings from "./component/navbar component/settings/Settings";
import AddCommunities from "./component/sidebar component/communities/AddCommunities";
import ListCommunities from "./component/sidebar component/communities/ListCommunities";
import Dashboard from "./component/sidebar component/dashboard/Dashboard";
import AddFAQ from "./component/sidebar component/faq/AddFAQ";
import ListFAQ from "./component/sidebar component/faq/ListFAQ";
import Feedback from "./component/sidebar component/feedback/Feedback";
import AddCategory from "./component/sidebar component/habbitCategory/AddCategory";
import ListCategory from "./component/sidebar component/habbitCategory/ListCategory";
import AddSubCategory from "./component/sidebar component/habbitSubCategory/AddSubCategory";
import ListSubCategory from "./component/sidebar component/habbitSubCategory/ListSubCategory";
import AddInterest from "./component/sidebar component/interest/AddInterest";
import ListInterest from "./component/sidebar component/interest/ListInterest";
import AddLanguage from "./component/sidebar component/language/AddLanguage";
import ListLanguage from "./component/sidebar component/language/ListLanguage";
import AddPage from "./component/sidebar component/page/AddPage";
import ListPage from "./component/sidebar component/page/ListPage";
import Payment from "./component/sidebar component/payment/Payment";
import AddPlan from "./component/sidebar component/plan/AddPlan";
import ListPlan from "./component/sidebar component/plan/ListPlan";
import AddPreference from "./component/sidebar component/preference/AddPreference";
import ListPreference from "./component/sidebar component/preference/ListPreference";
import AddQualities from "./component/sidebar component/qualities/AddQualities";
import ListQualities from "./component/sidebar component/qualities/ListQualities";
import AddRelation from "./component/sidebar component/relation goal/AddRelation";
import ListRelation from "./component/sidebar component/relation goal/ListRelation";
import AddReligion from "./component/sidebar component/religion/AddReligion";
import ListReligion from "./component/sidebar component/religion/ListReligion";
import Report from "./component/sidebar component/report/Report";
import AddReport from "./component/sidebar component/reportCategory/AddReport";
import ListReport from "./component/sidebar component/reportCategory/ListReport";
import UserInfo from "./component/sidebar component/user/UserInfo";
import UserList from "./component/sidebar component/user/UserList";
import useAuthToken from "./hooks/useAuthToken";

function App() {
  const { token, loading } = useAuthToken();

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Routes>
        <Route path="/" element={<AdminLogin />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify-otp" element={<OtpPage />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/home" element={token ? <Home /> : <Navigate to="/" />}>
          <Route index element={<Navigate to="dashboard" />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="add-interest" element={<AddInterest />} />
          <Route path="add-interest/:id" element={<AddInterest />} />
          <Route path="list-interest" element={<ListInterest />} />
          <Route path="add-language" element={<AddLanguage />} />
          <Route path="add-language/:id" element={<AddLanguage />} />
          <Route path="list-language" element={<ListLanguage />} />
          <Route path="add-religion" element={<AddReligion />} />
          <Route path="add-religion/:id" element={<AddReligion />} />
          <Route path="list-religion" element={<ListReligion />} />
          <Route path="add-relation" element={<AddRelation />} />
          <Route path="add-relation/:id" element={<AddRelation />} />
          <Route path="list-relation" element={<ListRelation />} />
          <Route path="add-communities" element={<AddCommunities />} />
          <Route path="add-communities/:id" element={<AddCommunities />} />
          <Route path="list-communities" element={<ListCommunities />} />
          <Route path="add-qualities" element={<AddQualities />} />
          <Route path="add-qualities/:id" element={<AddQualities />} />
          <Route path="list-qualities" element={<ListQualities />} />
          <Route path="add-category" element={<AddCategory />} />
          <Route path="add-category/:id" element={<AddCategory />} />
          <Route path="list-category" element={<ListCategory />} />
          <Route path="add-sub-category/:id" element={<AddSubCategory />} />
          <Route path="list-sub-category" element={<ListSubCategory />} />
          <Route path="add-sub-category" element={<AddSubCategory />} />
          <Route path="add-preference" element={<AddPreference />} />
          <Route path="add-preference/:id" element={<AddPreference />} />
          <Route path="list-preference" element={<ListPreference />} />
          <Route path="add-faq" element={<AddFAQ />} />
          <Route path="add-faq/:id" element={<AddFAQ />} />
          <Route path="list-faq" element={<ListFAQ />} />
          {/* <Route path="add-plan" element={<AddPlan />} /> */}
          <Route path="add-plan/:id" element={<AddPlan />} />
          <Route path="plan" element={<ListPlan />} />
          <Route path="payment" element={<Payment />} />
          <Route path="add-report" element={<AddReport />} />
          <Route path="add-report/:id" element={<AddReport />} />
          <Route path="list-report" element={<ListReport />} />
          <Route path="report" element={<Report />} />
          <Route path="feedback" element={<Feedback />} />
          <Route path="user" element={<UserList />} />
          <Route path="user-info/:id" element={<UserInfo />} />
          <Route path="add-page" element={<AddPage />} />
          <Route path="add-page/:id" element={<AddPage />} />
          <Route path="page" element={<ListPage />} />
          <Route path="account" element={<Account />} />
          <Route path="settings" element={<Settings />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
